export default __webpack_public_path__ + "static/media/Img_FindYourJoy_02.bb547b77.png";